import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";

/**
 * Loading screen for specifically for mailbox group page only.
 *
 * @returns a JSX element consisting of skeleton of mailbox group page's
 *  content's skeleton with 8 mailbox cards.
 */
export function LoadingScreen() {
  return (
    <div className="mx-auto flex w-full max-w-[500px] flex-col px-4 sm:px-0">
      {/* Title skeleton */}
      <Box className="w-3/4 self-start sm:w-[316px]">
        <Skeleton
          animation="wave"
          variant="text"
          width="100%"
          height={34}
          sx={{ borderRadius: 1 }}
        />
      </Box>

      <div className="h-3" />

      {/* Group description skeleton */}
      <Box className="w-full self-start sm:w-[496px]">
        <Skeleton
          animation="wave"
          variant="text"
          width="100%"
          height={15}
          sx={{ borderRadius: 1 }}
        />
      </Box>

      <div className="h-7" />

      {/* Recipient section header skeleton */}
      <Box className="w-1/2 self-start sm:w-[224px]">
        <Skeleton
          animation="wave"
          variant="text"
          width="100%"
          height={28}
          sx={{ borderRadius: 1 }}
        />
      </Box>

      <div className="h-5" />

      {/* Search bar skeleton */}
      <Box className="w-full max-w-xl">
        <Skeleton
          animation="wave"
          variant="rectangular"
          width="100%"
          height={50}
          sx={{ borderRadius: "25px" }}
        />
      </Box>

      <div className="h-5" />

      {/* Eight mailbox cards's skeletons */}
      <Grid container spacing={2}>
        {Array.from({ length: 8 }).map((_, i) => (
          <Grid item xs={12} sm={6} key={i}>
            <Box className="mx-auto w-full sm:mx-0 sm:w-[243px]">
              <Card
                variant="outlined"
                sx={{
                  borderRadius: "14px",
                  boxShadow: "0px 0px 6px rgba(0,0,0,0.12)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: 53,
                    px: 1,
                  }}
                >
                  {/* Avatar skeleton */}
                  <Skeleton variant="circular" width={32} height={32} />

                  {/* Name and email skeletons */}
                  <Box sx={{ ml: 1, flexGrow: 1 }}>
                    <Skeleton variant="text" width="80%" height={20} />
                    <Skeleton variant="text" width="60%" height={12} />
                  </Box>

                  {/* Rigt arrow skeleton */}
                  <Skeleton variant="circular" width={24} height={24} />
                </Box>
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
